import type { StoryblokConfigSlug } from '~/types/storyblokConfigSlug';
import type { CountryLanguages } from '~/types/countryLanguages';
import { resolveSectionPath } from '~/utils/resolveSectionPath';

export function findCurrentSectionConfig(
    registry: StoryblokConfigSlug[] | null | undefined,
    currentPath: string,
    urlSegment: string,
    country: string,
    lang: string,
    countryLanguages: CountryLanguages
): StoryblokConfigSlug | null {
    if (!registry) return null;

    const currentSegments = currentPath.replace(/^\/+/, '').split('/');
    let bestMatch: StoryblokConfigSlug | null = null;
    let bestMatchDepth = -1;

    for (const config of registry) {
        if (config.country !== country) continue;

        const slug = resolveSectionPath(config, lang, countryLanguages);
        if (slug === null) continue;

        const maybeTranslatedSlug = slug.length ? `/${slug}` : '';
        const fullPrefix = `${urlSegment}${maybeTranslatedSlug}`;
        const configSegments = fullPrefix.replace(/^\/+/, '').split('/');

        const isMatch = configSegments.every((segment, index) => segment === currentSegments[index]);
        if (isMatch && configSegments.length > bestMatchDepth) {
            bestMatch = config;
            bestMatchDepth = configSegments.length;
        }
    }

    return bestMatch;
}
